import Vue from "vue";
import mqtt from "mqtt";

export default class MqttClient {

  constructor() {
    this.connection = {
      host: Vue.prototype.filePre$.mqttHost,
      port: Vue.prototype.filePre$.mqttPort,
      endpoint: Vue.prototype.filePre$.mqttEndPoint,
      // 设置为 false 以在离线时接收 QoS 1 和 2 消息；
      clean: true,
      // 心跳时间，默认 60秒，设置 0 为禁用；
      // keepalive: 60,
      // 默认 30 * 1000毫秒，收到 CONNACK 之前等待的时间，即连接超时时间；
      connectTimeout: 4000,
      // 默认 1000 毫秒，两次重新连接之间的间隔，客户端 ID 重复、认证失败等客户端会重新连接；设置为0时，代表关闭重连机制
      reconnectPeriod: 0,
      // 客户端 ID ，默认通过 'mqttjs_' + Math.random().toString(16).substr(2, 8) 随机生成；
      clientId: Vue.prototype.filePre$.mqttClientId + this.getuuid(),
      // clientId: this.filePre.mqttClientId + '2233',
      // 连接用户名（可选）；
      username: Vue.prototype.filePre$.mqttUsername,
      // 连接密码（可选）；
      password: Vue.prototype.filePre$.mqttPassword,
    };

    // 当前连接创立的client对象
    this._client = null;
    // 当前连接是否是主动退出的。 默认为false，如果客户端收到“close”当时此值为false时，代表用户是非主动与服务器断连，需要提示用户重新连接。
    this._initiative_quit = false;
    // 当前连接的回调事件对象
    this._callBack = null;
  }

  /**
   * 获取实例
   */
  static get instance() {

    if (!MqttClient._instance) {
      MqttClient._instance = new MqttClient();
    }
    return MqttClient._instance;
  }

  /**
   * uuid随机生成
   * @returns {string}
   */
  getuuid() {
    let uid = [];
    const hexDigits = "0123456789abcdefghijklmnopqrst";
    for (let i = 0; i < 32; i++) {
      uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    uid[6] = "4";
    uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1);
    const uuid = uid.join("");
    return uuid;
  }

  /**
   * 设置mqtt实例的clientId
   * <p>
   *  如果传入了一个确定的clientId，用此Id去覆盖默认的Id。
   *  此方法需要在connect()方法调用前使用。
   * </p>
   * @param clientId
   */
  setClientId(clientId = '') {
    if (clientId) {
      this.connection.clientId = clientId
    }
  }

  /**
   * 设置连接的遗嘱消息
   *
   * <p>
   *  如果需要设置遗嘱消息，在mqtt连接之前调用。 mqtt连接建立后将无法设置遗嘱消息
   *
   *  will： a message that will sent by the broker automatically when the client disconnect badly. The format is:
    *    topic: the topic to publish
    *    payload: the message to publish
    *    qos: the QoS
    *    retain: the retain flag
    *    properties: properties of will by MQTT 5.0:
    *    willDelayInterval: representing the Will Delay Interval in seconds number,
    *    payloadFormatIndicator: Will Message is UTF-8 Encoded Character Data or not boolean,
    *    messageExpiryInterval: value is the lifetime of the Will Message in seconds and is sent as the Publication Expiry Interval when the Server publishes the Will Message number,
    *    contentType: describing the content of the Will Message string,
    *    responseTopic: String which is used as the Topic Name for a response message string,
    *    correlationData: The Correlation Data is used by the sender of the Request Message to identify which request the Response Message is for when it is received binary,
    *    userProperties: The User Property is allowed to appear multiple times to represent multiple name, value pairs object
   * </p>
   */
  setWillMessage(willMessage = {}) {
    this.connection.will = willMessage
  }

  /**
   *  创建连接
   */
  connect() {
    // 连接字符串, 通过协议指定使用的连接方式
    // ws 未加密 WebSocket 连接
    // wss 加密 WebSocket 连接
    // mqtt 未加密 TCP 连接
    // mqtts 加密 TCP 连接
    // wxs 微信小程序连接
    // alis 支付宝小程序连接
    const { host, port, endpoint, ...options } = this.connection;
    const connectUrl = `wss://${host}:${port}${endpoint}`;
    try {
      this._client = mqtt.connect(connectUrl, options);
    } catch (error) {
      // console.log(new Date() + "mqtt.connect error", error);
      if (this._callBack) {
        this._callBack("error", "Connection failed");
      }
    }

    this._client.on("connect", () => {
      // console.log("Connection succeeded!", this.connection.clientId, new Date());
      this._initiative_quit = false
      if (this._callBack) {
        this._callBack("connect", this.connection.clientId);
      }
    });

    this._client.on("error", (error) => {
      // console.log(new Date() + "Connection failed", error);
      if (this._callBack) {
        this._callBack("error", "Connection failed");
      }
    });

    this._client.on("message", (topic, message) => {
      // console.log(`Received message ${message} from topic ${topic}`);

      // message = JSON.parse(this.utf8ArrayToStr(message));
      message = JSON.parse(message.toString());
      if (this._callBack) {
        this._callBack("message", { topic, message });
      }
    });

    this._client.on("close", () => {
      // console.log("Connection closed!", this.connection.clientId, new Date())
      if (this._callBack) {
        this._callBack('close', this._initiative_quit)
      }
    })
  }

  /**
   * 以当前实例重新连接服务器
   */
  reconnect() {
    // 重连会调用退出函数，此时将是否是主动退出置位true。 在重连成功后，会在连接重构回调内将其在置位false
    this._initiative_quit = true
    let _this = this
    // 主动调用mqtt的退出，等待退出成功后再执行重连
    this._client.end(true, {}, () => {
      _this._client.reconnect()
    });
  }
  /**
   * 主动关闭mqtt连接
   */
  end() {
    return new Promise(resolve => {
      // 主动退出连接置位true
      this._initiative_quit = true
      // 回调函数置位true
      this._callBack = null;
      // mqttClient的实例置为空
      MqttClient._instance = null
      // 如果连接不存在，不做后续处理
      if (!this._client) {
        resolve()
      } else {
        // 如果连接实例仍然存在，关闭连接，销毁实例
        let _this = this
        this._client.end(true, {}, () => {
          // 关闭连接成功后，将客户端置位空
          _this._client = null;
          resolve()
        });
      }

    })
  }

  utf8ArrayToStr(array) {
    var out, i, len, c;
    var char2, char3;

    out = "";
    len = array.length;
    i = 0;
    while (i < len) {
      c = array[i++];
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += String.fromCharCode(c);
          break;
        case 12:
        case 13:
          // 110x xxxx   10xx xxxx
          char2 = array[i++];
          out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = array[i++];
          char3 = array[i++];
          out += String.fromCharCode(
            ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
          );
          break;
      }
    }
    return out;
  }

  /**
   * 注册回调
   */
  registerCallBack(callback) {
    this._callBack = callback;
  }

  /**
   *  订阅主题
   * @param subScripition
   */
  doSubscribe(subScripition) {
    const { topic, qos } = subScripition;
    this._client.subscribe(topic, { qos }, (error, res) => {
      if (error) {
        // console.log("Subscribe to topics error", error);
        return;
      }
      // console.log("Subscribe to topics res", res);
    });
  }

  /**
   *  取消订阅
   * @param subscription
   */
  doUnSubscribe(subscription) {
    const { topic } = subscription;
    // console.log("unSubscribe ...");
    this._client.unsubscribe(topic, (error) => {
      if (error) {
        // console.log("Unsubscribe error", error);
      }
    });
  }

  doPublish(opt) {
    const { topic, qos, retain, payload } = opt;
    console.log(topic, qos, retain, payload);
    this._client.publish(topic, payload, { qos, retain }, (error) => {
      if (error) {
        console.log("Publish error", error);
      }
    });
  }
}

